import React, { createContext, useCallback, useContext, useState, useEffect } from 'react';
import { useTheme } from './ThemeProvider';
import { useWindowResize, useDebounce } from '../utils/hooks';
var BreakpointsContext = createContext([]);
/*
  BreakpointsProvider attaches an event listener to window resize to keep track of which breakpoints are active at all times.
  active breakpoints are kept in a a string array( e.g. ['xs', 'sm', 'md'] ), this way components that only care about a
  specific breakpoint can simply check if that one is in the array or not.

  The useBreakpoints hook is a simple useContext attach to the context of the BreakpointsProvider.
*/
var BreakpointsProvider = function (_a) {
    var children = _a.children;
    var theme = useTheme();
    var _b = useState([]), activeBreakpoints = _b[0], setActiveBreakpoints = _b[1];
    var getActiveBreakpoints = useCallback(function () {
        var width = window.innerWidth;
        var breakpoints = Object.entries(theme.breakpoints)
            .filter(function (_a) {
            var value = _a[1];
            return value <= width;
        })
            .map(function (_a) {
            var key = _a[0];
            return key;
        }); // to let typescript understand key type
        setActiveBreakpoints(breakpoints);
    }, [theme]);
    // get breakpoints once on mount
    useEffect(function () {
        getActiveBreakpoints();
    }, []);
    // run getActiveBreakpoints debounced on window resize
    var dbGetActiveBreakpoints = useDebounce(getActiveBreakpoints, 100);
    useWindowResize(dbGetActiveBreakpoints);
    return React.createElement(BreakpointsContext.Provider, { value: activeBreakpoints }, children);
};
function useBreakpoints() {
    return useContext(BreakpointsContext);
}
export { BreakpointsProvider as default, BreakpointsProvider, useBreakpoints };
